module.exports = __webpack_public_path__ + "img/11.f603345c.png";